/**
 * CSS rules injected into every replay iframe (live co-watch and recorded
 * playback) via rrweb's `insertStyleRules`.
 *
 * Recorded pages routinely gate their main content behind a CSS *entrance*
 * animation — e.g. a Tailwind/shadcn/Lovable app wraps the page body in
 * `<article class="animate-fade-in">` where:
 *
 *   .animate-fade-in { animation: fade-in .5s ease-out; }
 *   @keyframes fade-in { 0% { opacity: 0 } 100% { opacity: 1 } }
 *
 * rrweb freezes CSS animations at the current playhead so it can scrub them, so
 * on a fresh boot (live watch-start, or content that is already present in the
 * first full snapshot) such an element is stuck on the 0% / opacity:0 frame and
 * renders blank — while un-animated chrome (nav, sidebar) paints normally. The
 * symptom is a page whose shell shows but whose main content is invisible.
 *
 * Disabling animations and transitions makes every element paint at its settled
 * base state, which is exactly what a replay should show: the content as the
 * visitor actually saw it, not mid-entrance. This is a deliberate trade — we
 * favour "always show the content" over faithfully re-playing entrance effects.
 */
export const REPLAY_ANIMATION_RESET = [
    '*, *::before, *::after { animation: none !important; transition: none !important; }',
];
//# sourceMappingURL=replayStyle.js.map